'use client';
import React, { useEffect } from 'react';

import { useAppDispatch } from '@/lib/hooks';
import { setAverageInsightData, setUnopenedInsightData } from '@/lib/slices/insights-slice';

import InsightsCacheService from '@/services/storage/insights-cache-service';

const AdminLayout = ({
  children,
}: Readonly<{
  children: React.ReactNode;
}>): React.JSX.Element => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    // Set state for Insights from cookie
    const cookie = InsightsCacheService.getInsightCookie();
    dispatch(setUnopenedInsightData(cookie.unopened));
    dispatch(setAverageInsightData(cookie.average));
  }, []);

  return (
    <section id='admin-layout' className='page-container'>
      {children}
    </section>
  );
};

export default AdminLayout;
